import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type ManageScheduledRunConfirmationModalProps = {
  onConfirm: () => void;
};

const ManageScheduledRunConfirmationModal = create(function ManageScheduledRunConfirmationModal({
  onConfirm,
}: ManageScheduledRunConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Delete scheduling"
      confirmationButtonLabel="Delete"
      confirmationButtonVariant="dangerPrimary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to delete <strong>Run scheduling</strong>?
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showManageScheduledRunConfirmationModal = (
  props: ManageScheduledRunConfirmationModalProps
) => show(ManageScheduledRunConfirmationModal, props);
